/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  LicensingEnrollment,
  LicensingEnrollmentFromJSON,
  LicensingEnrollmentToJSON,
} from './'

/**
 * Body to create licensing enrollments
 * @export
 * @interface CreateLicensingEnrollment
 */
export interface CreateLicensingEnrollment {
  /**
   *
   * @type {Array<LicensingEnrollment>}
   * @memberof CreateLicensingEnrollment
   */
  licensingEnrollments: Array<LicensingEnrollment>
}

export function CreateLicensingEnrollmentFromJSON(
  json: any
): CreateLicensingEnrollment {
  return CreateLicensingEnrollmentFromJSONTyped(json, false)
}

export function CreateLicensingEnrollmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateLicensingEnrollment {
  if (json === undefined || json === null) {
    return json
  }
  return {
    licensingEnrollments: (json['licensingEnrollments'] as Array<any>).map(
      LicensingEnrollmentFromJSON
    ),
  }
}

export function CreateLicensingEnrollmentToJSON(
  value?: CreateLicensingEnrollment | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    licensingEnrollments: (value.licensingEnrollments as Array<any>).map(
      LicensingEnrollmentToJSON
    ),
  }
}
